import { useEffect, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { CastContext } from './cast-context';
import { CastRemotePlayer, CastSender, CastContext as CastContextType } from './interfaces';
import { getContext, getPlayer, getSender } from './utils/getters';
import { retryValue } from './utils/retry';

export function CastProvider({ children }: { children: React.ReactNode }) {
  const [sender, setSender] = useState<CastSender | undefined>(() => getSender());
  const [context, setContext] = useState<CastContextType | undefined>(() => getContext());
  const [player, setPlayer] = useState<CastRemotePlayer | undefined>(() => getPlayer());
  const [isPending, setIsPending] = useState(() => sender === undefined);

  useEffect(() => {
    (async () => {
      const globalSender = await retryValue(() => getSender(), { ms: 95, retries: 15 });
      const globalContext = await retryValue(() => getContext(), { ms: 95, retries: 15 });
      const globalPlayer = await retryValue(() => getPlayer(), { ms: 95, retries: 15 });
      unstable_batchedUpdates(() => {
        setSender(globalSender);
        setContext(globalContext);
        setPlayer(globalPlayer);
        setIsPending(false);
      });
    })();
  }, []);

  return (
    <CastContext.Provider
      value={{
        sender,
        context,
        player,
        isPending,
      }}
    >
      {children}
    </CastContext.Provider>
  );
}
